import store from '../store'

const toast = {
    success: (msg) => {
        const obj = {
            message: msg,
            top: false,
            right: true,
            left: false,
            bottom: true,
            color: 'green',
            transition: 'fade-transition',
            timeout: 5000,
          }
          store.dispatch('toast/toast', obj)
        },
    error: (msg) => {
        const obj = {
            message: msg,
            top: false,
            right: true,
            left: false,
            bottom: true,
            color: 'red',
            transition: 'fade-transition',
            timeout: 10000,
            }
            store.dispatch('toast/toast', obj)
        },
}

export default toast
